// @ts-ignore
import { tw } from "@careinfo/tailwind";
import { UploadCloudIcon } from "lucide-react";
import APIS from "../../../constant/Endpoint";
import Button from "../../Reusable/Button";
import EmailComboboxInput from "../../Reusable/EmailComboboxInput/EmailComboboxInput";
import MultiEmailInput from "../../Reusable/MultiEmailInput/MultiEmailInput";
import { RichTextEditor } from "../../Reusable/RichTextEditor";
import TextField from "../../Reusable/TextInput";

const EmailCampaignForm = (props: any) => {
  const {
    register,
    errors,
    watch,
    setValue,
    getValues,
    clearErrors,
    handlePlusButton,
    control,
    handleFileButton,
  } = props;

  return (
    <div>
      <TextField
        placeholder="Enter Campaign Name"
        label="Campaign Name"
        register={register("name")}
        errors={errors.name}
      />
      <div className={tw`flex gap-4 mt-2`}>
        <div className={tw`w-full`}>
          <MultiEmailInput
            label={<div>To</div>}
            value={watch("recipient") || []}
            onChange={(emails) => setValue("recipient", emails)}
            error={errors.recipient}
          />
        </div>
        <div className={tw`w-24 relative top-4`}>
          <div className={tw`flex justify-center items-center`}>
            <Button
              label={
                <div className="flex justify-center items-center w-full h-full">
                  <UploadCloudIcon className="text-white w-5 h-5" />
                </div>
              }
              type="button"
              onClick={handleFileButton}
            />
          </div>
        </div>
      </div>

      <div className={tw`flex gap-4`}>
        <div className={tw`w-full`}>
          <EmailComboboxInput
            url={APIS.SENDER_EMAIL}
            queryKey="email"
            register={register("sender_email")}
            errors={errors.sender_email}
            name="sender_email"
            props={{ is_active: true }}
            label={
              <div>
                From
                <span> - Select Your Sender ID</span>
              </div>
            }
            setValue={setValue}
            watch={watch}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
        <div className={tw`w-24 relative top-6`}>
          <div className={tw`text-[20px] leading-none text-center`}>
            <Button label="+" type="button" onClick={handlePlusButton} />
          </div>
        </div>
      </div>
      <TextField
        label={<div>Subject</div>}
        placeholder="Write a subject here..."
        register={register("subject")}
        errors={errors.subject}
      />
      <RichTextEditor
        register={register("content")}
        setValue={setValue}
        errors={errors.content}
        label={<div>Message</div>}
        registeredKey="content"
        name="content"
        control={control}
      />
    </div>
  );
};

export default EmailCampaignForm;
